'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@/lib/utils';
import { AnimatePresence, motion } from 'framer-motion';
import { useTranslations } from 'next-intl';
import { useEffect, useState } from 'react';
const VIEWER_PRESETS = [1000, 10000, 50000, 100000, 1000000];
const VIEWER_EARNINGS_MAP = [2, 20, 100, 200, 2000];
function HeroCalculator() {
  const $ = _c(64);
  const t = useTranslations();
  const [sliderValue, setSliderValue] = useState(2);
  const [presetIndex, setPresetIndex] = useState(2);
  const [isClient, setIsClient] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => setIsClient(true);
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  if (!isClient) {
    return null;
  }
  const nearestIndex = Math.round(sliderValue);
  const alignedViewers = VIEWER_PRESETS[nearestIndex];
  const earnings = VIEWER_EARNINGS_MAP[nearestIndex];
  const elsewhereEarnings = Math.round(earnings / 2 / 10) * 10;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = e => {
      const val = Number(e.target.value);
      setSliderValue(val);
      setPresetIndex(Math.round(val));
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleSliderChange = t2;
  let t3;
  if ($[3] !== sliderValue) {
    t3 = () => {
      const nearest = Math.round(sliderValue);
      setSliderValue(nearest);
      setPresetIndex(nearest);
    };
    $[3] = sliderValue;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleSliderMouseUp = t3;
  let t4;
  if ($[5] !== sliderValue) {
    t4 = () => sliderValue / (VIEWER_PRESETS.length - 1) * 100;
    $[5] = sliderValue;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const getSliderPercentage = t4;
  let t5;
  if ($[7] !== t) {
    t5 = t("partnership.creator-calculator.label");
    $[7] = t;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t5) {
    t6 = <p className="text-vive-brand-50 text-sm font-semibold tracking-widest uppercase md:text-base">{t5}</p>;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  let t8;
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      opacity: 0,
      scale: 1.05
    };
    t8 = {
      opacity: 1,
      scale: 1
    };
    t9 = {
      opacity: 0,
      scale: 0.98
    };
    $[11] = t7;
    $[12] = t8;
    $[13] = t9;
  } else {
    t7 = $[11];
    t8 = $[12];
    t9 = $[13];
  }
  let t10;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      duration: 0.14,
      ease: [0.2, 0.9, 0.3, 1]
    };
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== earnings) {
    t11 = <span className="inline-block text-[96px] leading-24 font-bold text-white">${earnings}</span>;
    $[15] = earnings;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <span className="ml-2 inline-block text-xl font-medium text-[#FFFFFF66]">USD</span>;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== earnings || $[19] !== t11) {
    t13 = <div className="mt-[30px]"><AnimatePresence mode="wait"><motion.div key={earnings} initial={t7} animate={t8} exit={t9} transition={t10} className="flex items-baseline">{t11}{t12}</motion.div></AnimatePresence></div>;
    $[18] = earnings;
    $[19] = t11;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== alignedViewers || $[22] !== t) {
    t14 = t.rich("partnership.creator-calculator.with-viewers", {
      viewers: alignedViewers >= 1000000 ? "1M" : `${alignedViewers / 1000}K`,
      strong: _temp
    });
    $[21] = alignedViewers;
    $[22] = t;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== t14) {
    t15 = <p className="text-sm leading-5 text-[#FFFFFF80]">{t14}</p>;
    $[24] = t14;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== elsewhereEarnings || $[27] !== t) {
    t16 = t("partnership.creator-calculator.vs-elsewhere", {
      amount: elsewhereEarnings
    });
    $[26] = elsewhereEarnings;
    $[27] = t;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== t16) {
    t17 = <p className="mt-1.5 text-xs text-[#FFFFFF4D]">{t16}</p>;
    $[29] = t16;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] !== t15 || $[32] !== t17) {
    t18 = <div className="mt-4 flex flex-col">{t15}{t17}</div>;
    $[31] = t15;
    $[32] = t17;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  let t19;
  if ($[34] !== t13 || $[35] !== t18 || $[36] !== t6) {
    t19 = <div className="text-center">{t6}{t13}{t18}</div>;
    $[34] = t13;
    $[35] = t18;
    $[36] = t6;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] !== presetIndex) {
    t20 = VIEWER_PRESETS.map((preset, index) => <button key={preset} onClick={() => {
      setPresetIndex(index);
      setSliderValue(index);
    }} className={cn("h-[45px] w-12 rounded-[10px] border-[1.18px] border-solid text-[14px] font-semibold transition-all duration-200 md:w-[66px]", presetIndex === index ? "text-vive-brand-40 border-vive-brand-50 bg-[rgba(51,194,233,0.1)] font-bold shadow-[0px_0px_12px_0px_rgba(0,160,203,0.3)]" : "border-[rgba(255,255,255,0.15)] bg-[rgba(33,42,57,0.4)] text-[rgba(255,255,255,0.5)] hover:bg-[rgba(89,102,119,0.5)]")}>{preset >= 1000000 ? "1M" : `${preset / 1000}K`}</button>);
    $[38] = presetIndex;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  let t21;
  if ($[40] !== t20) {
    t21 = <div className="mt-12 flex flex-wrap justify-center gap-3">{t20}</div>;
    $[40] = t20;
    $[41] = t21;
  } else {
    t21 = $[41];
  }
  const t22 = `${getSliderPercentage()}%`;
  let t23;
  if ($[42] !== t22) {
    t23 = <div className="absolute h-full rounded-full bg-linear-to-r from-cyan-500 to-cyan-400 transition-all duration-100" style={{
      width: t22
    }} />;
    $[42] = t22;
    $[43] = t23;
  } else {
    t23 = $[43];
  }
  let t24;
  if ($[44] !== handleSliderMouseUp || $[45] !== sliderValue) {
    t24 = <input type="range" min={0} max={VIEWER_PRESETS.length - 1} step={0.01} value={sliderValue} onChange={handleSliderChange} onMouseUp={handleSliderMouseUp} onTouchEnd={handleSliderMouseUp} className="absolute top-1/2 left-0 h-1 w-full -translate-y-1/2 cursor-pointer appearance-none bg-transparent opacity-0" />;
    $[44] = handleSliderMouseUp;
    $[45] = sliderValue;
    $[46] = t24;
  } else {
    t24 = $[46];
  }
  const t25 = `calc(${getSliderPercentage()}% - 12px)`;
  let t26;
  if ($[47] !== t25) {
    t26 = <div className="pointer-events-none absolute top-1/2 h-6 w-6 -translate-y-1/2 transform rounded-full bg-white shadow-[0_0_14px_4px_rgba(0,255,255,0.6)] transition-all duration-50" style={{
      left: t25
    }} />;
    $[47] = t25;
    $[48] = t26;
  } else {
    t26 = $[48];
  }
  let t27;
  if ($[49] !== t23 || $[50] !== t24 || $[51] !== t26) {
    t27 = <div className="relative h-1 w-full rounded-full bg-gray-700">{t23}{t24}{t26}</div>;
    $[49] = t23;
    $[50] = t24;
    $[51] = t26;
    $[52] = t27;
  } else {
    t27 = $[52];
  }
  let t28;
  if ($[53] !== t) {
    t28 = t("partnership.creator-calculator.footer");
    $[53] = t;
    $[54] = t28;
  } else {
    t28 = $[54];
  }
  let t29;
  if ($[55] !== t28) {
    t29 = <p className="mt-2 text-center text-xs text-[#FFFFFF4D]">{t28}</p>;
    $[55] = t28;
    $[56] = t29;
  } else {
    t29 = $[56];
  }
  let t30;
  if ($[57] !== t27 || $[58] !== t29) {
    t30 = <div className="relative mt-12 flex w-full flex-col gap-4 px-6 md:px-0">{t27}{t29}</div>;
    $[57] = t27;
    $[58] = t29;
    $[59] = t30;
  } else {
    t30 = $[59];
  }
  let t31;
  if ($[60] !== t19 || $[61] !== t21 || $[62] !== t30) {
    t31 = <div className="flex min-h-[471px] w-full flex-col items-center rounded-2xl border border-[rgba(255,255,255,0.08)] bg-[rgba(33,42,57,0.2)] pt-12 pb-5 backdrop-blur-[50px] md:px-40 md:py-16 lg:px-10 lg:pt-10">{t19}{t21}{t30}</div>;
    $[60] = t19;
    $[61] = t21;
    $[62] = t30;
    $[63] = t31;
  } else {
    t31 = $[63];
  }
  return t31;
}
function _temp(chunks) {
  return <span className="text-sm font-bold text-[#FFFFFFB2]">{chunks}</span>;
}
export default HeroCalculator;